import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-modal-sheet-alert',
  templateUrl: './modal-sheet-alert.component.html',
  styleUrls: ['./modal-sheet-alert.component.scss'],
})
export class ModalSheetAlertComponent  implements OnInit {

  @Input() status: string;
  @Input() autoClose: boolean;
  @Input() duration: number;
  @Input() showConfirmButton: boolean;
  @Input() title: string;
  @Input() text: string;
  @Input() code : string | number;

  constructor(
    public modalCtrl : ModalController
  ) { }

  ngOnInit() {
    if (this.autoClose) {
      setTimeout(() => {
        this.dismissModal();
      }, this.duration);
    }
  }

  dismissModal() {
    this.modalCtrl.dismiss();
  }

}
